import { Helpers, Services, IFinalResponse } from '@smiles/core-smiles';

import { APIEnvs } from '@smiles/core-smiles/dist/types';
import { APIEnvs as EngineEnvs } from '@smiles/core-engine/dist/types';
import { InitializeTypes, Config } from '@smiles/core-engine';

export { Services as UtilsServices } from '@smiles/core-utils';
export { Services as AccountServices, Helpers as AccountHelpers } from '@smiles/core-account';

const CoreHelpers = Helpers;
const CoreServices = Services;

export const checkEnv = (forceEnv?: EngineEnvs) => {
  if(forceEnv) {
    return forceEnv;
  }

  if (window.location.origin.includes('localhost')) {
    return 'HML5';
  }

  if (window.location.origin.includes('login.')) {
    const isDotDevEnv = window.location.origin.includes('.dev');
    const isDotHmlEnv = window.location.origin.includes('.hml');
    if (isDotDevEnv || isDotHmlEnv) {
      const numberPattern = isDotDevEnv ? /dev(\d+)/ : /hml(\d+)/;
      const url = window.location.origin;
      const aux = url.match(numberPattern);
      if (aux) {
        const env = aux[0].toUpperCase();
        return `${env}-N` as APIEnvs;
      }
    }

    if (window.env && window.env.indexOf('portal-') === 0) {
      const aux = window.env.split('-');
      return aux[1].toUpperCase().replace('UAT', 'HML') as APIEnvs;
    }
    return 'PRD';
  }

  if (window.location.origin.includes('login-dev')) {
    return 'DEV1';
  }

  if (window.location.origin.includes('login-hml')) {
    return 'HML1';
  }

  return 'MOCK';
};
const ENV_CORE = checkEnv().toLocaleUpperCase();

const configLib: InitializeTypes = {
  channel: 'WEB',
  loggerXstate: false,
  service: {
    environment: ENV_CORE as any,
    logger: false,
    timeout: 60000,
    region: 'Brasil',
  },
  receiveConstants: true,
};

export const constants = {} as any;

export async function init() {
  const initResponse = await Config.initialize(configLib);

  console.log('[@core][init] success:', initResponse.success);

  const env = checkEnv();
  let siteKey = '6LcSG6oaAAAAAGooY4PRTvcb63uNDaBPvZ0FUaRk'; // prd
  if (env) {
    if (env.indexOf('DEV') === 0 || window.location.origin.indexOf('login.dev') > -1) {
      siteKey = '6LeN6KkaAAAAAMa65qTLLMBgB1uwMEEdcnyg2xvc';
    } else if (env.indexOf('HML') === 0 || window.location.origin.indexOf('login.uat') > -1) {
      siteKey = '6LcKUawaAAAAACD8tSTaz9_qupqeK98cae0o0VJq';
    }
  }

  constants.recaptcha = siteKey;

  sessionStorage.setItem('@core:smiles:auth0:initialize', JSON.stringify(initResponse));
}

export { CoreHelpers, CoreServices, Config };

export type { IFinalResponse };
